export const COOKIE = {
  NAME: "raip",
  MAX_AGE: 60 * 60 * 24 * 7, // 7 dias
  // refresh token: httpOnly (inacessível ao JS) e enviado só para as rotas BFF em /api
  REFRESH_NAME: "raip_refresh",
  REFRESH_PATH: "/api",
};
